import React from 'react';
import { Apps } from '~/shared';
import { AppAds } from '../AppAds';
import { AppAuction } from '../AppAuction';
import { AppJobElectrician } from '../AppJobElectrician';
import { AppLauncher } from '../AppLauncher';
import { AppMessage } from '../AppMessage';
import { AppMyBusiness } from '../AppMyBusiness';
import { AppTruckJob } from '../AppTruckJob';

export const AppList: Record<Apps, React.FC> = {
	[Apps.Launcher]: AppLauncher,
	[Apps.Camera]: AppMessage,
	[Apps.Message]: AppMessage,
	[Apps.Ads]: AppAds,
	[Apps.JobElectrician]: AppJobElectrician,
	[Apps.MyBusiness]: AppMyBusiness,
	[Apps.Auction]: AppAuction,
	[Apps.TruckJob]: AppTruckJob,
};
